import React, { useState, useEffect } from "react";
import { ExternalLink, AlertCircle, X } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function BoardroomAccessView({ link }) {
  // { link }
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  //   console.log("link", link);

  useEffect(() => {
    // Check for error parameter in URL
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get("error");

    if (error) {
      setErrorMessage(decodeURIComponent(error));
      setShowError(true);
    }
  }, []);

  const handleAccessBoardroom = () => {
    // window.open("/select-agent", "_blank");
    // navigate("/select-agent");
    window.open(link, "_blank");

    // window.open("/select-agent", "_blank");
  };

  const handleCloseError = () => {
    setShowError(false);
    // Remove error parameter from URL
    const url = new URL(window.location);
    url.searchParams.delete("error");
    window.history.replaceState({}, document.title, url.pathname);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center p-4">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Large background orbs */}
        {/* <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-indigo-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse delay-500"></div> */}

        {/* Medium floating orbs */}
        {/* <div className="absolute top-20 left-20 w-32 h-32 bg-cyan-400 rounded-full mix-blend-multiply filter blur-lg opacity-30 animate-float"></div>
        <div className="absolute top-40 right-32 w-28 h-28 bg-pink-400 rounded-full mix-blend-multiply filter blur-lg opacity-25 animate-float-reverse delay-700"></div>
        <div className="absolute bottom-32 left-1/3 w-24 h-24 bg-yellow-400 rounded-full mix-blend-multiply filter blur-lg opacity-30 animate-float delay-1500"></div>
        <div className="absolute bottom-20 right-20 w-36 h-36 bg-green-400 rounded-full mix-blend-multiply filter blur-lg opacity-25 animate-float-reverse delay-300"></div> */}

        {/* Small animated balls */}
        {/* <div className="absolute top-1/4 left-1/4 w-16 h-16 bg-violet-400 rounded-full mix-blend-multiply filter blur-md opacity-40 animate-bounce-slow"></div>
        <div className="absolute top-3/4 right-1/4 w-12 h-12 bg-teal-400 rounded-full mix-blend-multiply filter blur-md opacity-35 animate-bounce-slow delay-800"></div>
        <div className="absolute bottom-1/4 left-3/4 w-20 h-20 bg-orange-400 rounded-full mix-blend-multiply filter blur-md opacity-30 animate-bounce-slow delay-400"></div>
        <div className="absolute top-1/3 right-1/3 w-14 h-14 bg-rose-400 rounded-full mix-blend-multiply filter blur-md opacity-40 animate-bounce-slow delay-1200"></div> */}

        {/* Tiny sparkle balls */}
        {/* <div className="absolute top-16 left-1/2 w-8 h-8 bg-white rounded-full opacity-60 animate-twinkle"></div>
        <div className="absolute bottom-16 right-1/2 w-6 h-6 bg-white rounded-full opacity-50 animate-twinkle delay-600"></div>
        <div className="absolute top-1/2 left-16 w-10 h-10 bg-white rounded-full opacity-40 animate-twinkle delay-1000"></div>
        <div className="absolute top-1/2 right-16 w-7 h-7 bg-white rounded-full opacity-55 animate-twinkle delay-300"></div>
        <div className="absolute top-2/3 left-2/3 w-9 h-9 bg-white rounded-full opacity-45 animate-twinkle delay-900"></div> */}
      </div>

      {/* Error Alert */}
      {showError && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 max-w-md w-full mx-4">
          <div className="bg-red-500/20 backdrop-blur-lg border border-red-500/30 rounded-xl shadow-2xl p-4 my-3">
            <div className="flex items-start gap-3">
              <AlertCircle
                className="text-red-400 mt-0.5 flex-shrink-0"
                size={20}
              />
              <div className="flex-1">
                <h3 className="text-red-100 font-semibold mb-1">
                  Access Error
                </h3>
                <p className="text-red-200/80 text-sm leading-relaxed">
                  {errorMessage}
                </p>
              </div>
              <button
                onClick={handleCloseError}
                className="text-red-300 hover:text-red-100 transition-colors duration-200 p-1 hover:bg-red-500/20 rounded-lg"
              >
                <X size={16} />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Main centered box */}
      <div className="relative bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl shadow-2xl p-8 md:p-12 max-w-md w-full transform hover:scale-105 transition-all duration-300 ease-out hover:bg-white/15">
        {/* Glass effect overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent rounded-2xl"></div>

        {/* Content */}
        <div className="relative z-10 text-center">
          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-2 animate-fade-in">
            Welcome
          </h1>

          {/* Subtitle */}
          <p className="text-white/70 mb-6 text-lg animate-fade-in delay-200">
            This will open the boardroom window in a new tab.
          </p>

          {/* Access Button */}
          <button
            onClick={handleAccessBoardroom}
            className="cursor-pointer group relative inline-flex items-center justify-center gap-3 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white font-semibold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 ease-out focus:outline-none focus:ring-4 focus:ring-blue-500/50 animate-fade-in delay-400"
          >
            <span className="text-lg">Access Boardroom</span>
            <ExternalLink
              size={20}
              className="group-hover:rotate-12 transition-transform duration-300"
            />

            {/* Button glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl blur opacity-30 group-hover:opacity-50 transition-opacity duration-300 -z-10"></div>
          </button>

          {/* Decorative line */}
          <div className="mt-8 w-24 h-1 bg-gradient-to-r from-transparent via-white/30 to-transparent mx-auto animate-fade-in delay-600"></div>
        </div>
      </div>

      {/* Floating particles animation */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-white/30 rounded-full animate-bounce delay-0"></div>
        <div className="absolute top-3/4 right-1/4 w-1 h-1 bg-white/40 rounded-full animate-bounce delay-1000"></div>
        <div className="absolute bottom-1/4 left-3/4 w-1.5 h-1.5 bg-white/20 rounded-full animate-bounce delay-500"></div>
      </div>

      <style jsx>{`
        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slide-down {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0px) translateX(0px) scale(1);
          }
          25% {
            transform: translateY(-20px) translateX(10px) scale(1.05);
          }
          50% {
            transform: translateY(-10px) translateX(-5px) scale(0.95);
          }
          75% {
            transform: translateY(-30px) translateX(15px) scale(1.1);
          }
        }

        @keyframes float-reverse {
          0%,
          100% {
            transform: translateY(0px) translateX(0px) scale(1);
          }
          25% {
            transform: translateY(20px) translateX(-10px) scale(0.9);
          }
          50% {
            transform: translateY(10px) translateX(5px) scale(1.1);
          }
          75% {
            transform: translateY(30px) translateX(-15px) scale(0.85);
          }
        }

        @keyframes bounce-slow {
          0%,
          100% {
            transform: translateY(0px) scale(1);
          }
          50% {
            transform: translateY(-25px) scale(1.1);
          }
        }

        @keyframes twinkle {
          0%,
          100% {
            opacity: 0.2;
            transform: scale(0.8);
          }
          50% {
            opacity: 0.8;
            transform: scale(1.2);
          }
        }

        .animate-fade-in {
          animation: fade-in 0.8s ease-out forwards;
        }

        .animate-slide-down {
          animation: slide-down 0.5s ease-out forwards;
        }

        .animate-float {
          animation: float 6s ease-in-out infinite;
        }

        .animate-float-reverse {
          animation: float-reverse 8s ease-in-out infinite;
        }

        .animate-bounce-slow {
          animation: bounce-slow 4s ease-in-out infinite;
        }

        .animate-twinkle {
          animation: twinkle 3s ease-in-out infinite;
        }

        .delay-200 {
          animation-delay: 0.2s;
        }

        .delay-300 {
          animation-delay: 0.3s;
        }

        .delay-400 {
          animation-delay: 0.4s;
        }

        .delay-500 {
          animation-delay: 0.5s;
        }

        .delay-600 {
          animation-delay: 0.6s;
        }

        .delay-700 {
          animation-delay: 0.7s;
        }

        .delay-800 {
          animation-delay: 0.8s;
        }

        .delay-900 {
          animation-delay: 0.9s;
        }

        .delay-1000 {
          animation-delay: 1s;
        }

        .delay-1200 {
          animation-delay: 1.2s;
        }

        .delay-1500 {
          animation-delay: 1.5s;
        }
      `}</style>
    </div>
  );
}
